//common
import './common';

//components
import ProductGalleryCarousel from './blocks/slider-product-gallery'
import './blocks/slider-product-recipes'
import './blocks/slider-article'
import './blocks/slider-product'
import './blocks/accordion'
import './blocks/tooltip'
import Buy from './blocks/buy'
import './blocks/product-filter'

addEventListener('ajax:update-complete', () => {
    ProductGalleryCarousel.init();
    Buy.initHandler();
})